import { render, staticRenderFns } from "./BiddingEstimate.vue?vue&type=template&id=a5a60308&scoped=true&"
import script from "./BiddingEstimate.vue?vue&type=script&lang=js&"
export * from "./BiddingEstimate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a60308",
  null
  
)

export default component.exports